import { render, staticRenderFns } from "./EditBookingOptions.vue?vue&type=template&id=85e54270&"
import script from "./EditBookingOptions.vue?vue&type=script&lang=ts&"
export * from "./EditBookingOptions.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports